
<div mat-dialog-content class="w-full bg-white !p-0 !m-0">
  <form class="type-modal" [formGroup]="dataForm">
    <div class="card">
      <div class="flex items-start justify-between gap-4 mb-6">
        <h3 class="green decoration">Carga masiva</h3>
        <button type="button" (click)="dismiss()" class="flex items-center justify-center w-8 h-8 -mt-1 rounded-full text-gray-400 hover:text-gray-700 hover:bg-gray-100 transition" title="Cerrar" aria-label="Cerrar">
          <i class="fa-light fa-xmark text-[18px]"></i>
        </button>
      </div>
      <div class="form-wrapper mb-3">
        <span>Seleccionar archivo:</span>
        <div class="file-wrapper">
          <input type="file" (change)="massiveCharge($event)">
        </div>
      </div>

      <div *ngIf="importMessage" class="mt-4 rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-800">
        <p class="m-0 font-medium">
          <i class="fa-light fa-circle-exclamation mr-1"></i>
          {{ importMessage }}
        </p>
        <ul *ngIf="importErrors.length > 0" class="m-0 mt-2 max-h-56 overflow-y-auto list-disc pl-5 space-y-1">
          <li *ngFor="let error of importErrors">{{ error }}</li>
        </ul>
      </div>
    </div>
  </form>
</div>

<div mat-dialog-actions class="!m-0 w-full block">
  <div class="w-full flex justify-between actions_modal">
        <!-- <button cdkFocusInitial mat-button class="!hidden">Autofocus disabled</button> -->
        <button mat-button type="button" (click)="downloadTemplate()" class="btn btn-gray big">Descargar plantilla</button>
        <button mat-button type="button" (click)="sendData()" class="btn btn-primary big">Aceptar</button>
  </div>
</div>
